var map = {
	"./android-studio.png": 599,
	"./bootstrap.png": 3169,
	"./css.png": 4317,
	"./db.png": 6708,
	"./github-blue.png": 3578,
	"./github.png": 6348,
	"./github1.png": 7589,
	"./html.png": 6339,
	"./java.png": 9189,
	"./javascript.png": 8895,
	"./kotlin.png": 5068,
	"./linkedin.png": 9107,
	"./nodejs.png": 7747,
	"./php.png": 3965,
	"./postman.png": 438,
	"./react.png": 12,
	"./retrofit.png": 4425,
	"./sql.png": 8474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3022;